import { render, staticRenderFns } from "./MovementFilePage.vue?vue&type=template&id=e6e112aa&"
import script from "./MovementFilePage.vue?vue&type=script&lang=js&"
export * from "./MovementFilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports